/**
* @file 公共组件-图片上传组件
* */
<template>
  <div class="up-img">
    <div class="up-img-content">
      <!--多张图片上传-->
      <div
        class="content-img"
        :style="{ width: width + 'px', height: height + 'px' }"
        v-for="(file, index) in filesArr"
        :key="index"
      >
        <template v-if="file">
          <div class="content-img-actions">
            <i
              @click="removeFn(index)"
              v-show="!disabled"
              class="el-icon-delete"
            ></i>
            <i @click="showFn(index)" class="el-icon-view"></i>
          </div>
          <img
            class="up-img-content-img"
            :src="`${beforeUrl || ''}${file}${afterUrl || ''}`"
          />
        </template>
      </div>

      <!--单张图片上传-->
      <div
        class="content-img"
        :style="{ width: width + 'px', height: height + 'px' }"
        v-if="max === 1 && file"
      >
        <template v-if="file">
          <div class="content-img-actions">
            <i
              @click="removeFn(file)"
              v-show="!disabled"
              class="el-icon-delete"
            ></i>
            <i @click="showFn" class="el-icon-view"></i>
          </div>
          <img
            class="up-img-content-img"
            :src="`${beforeUrl || ''}${file}${afterUrl || ''}`"
          />
        </template>
      </div>

      <!--上传前-->
      <div
        class="content-img content-img-up"
        :style="{ width: width + 'px', height: height + 'px' }"
        v-if="
          (max > 1 && filesArr.length < Number(max)) || (max === 1 && !file)
        "
      >
        <img class="content-img-up-icon" src="../assets/img/add.png" alt="" />
        <input
          :disabled="disabled"
          class="content-img-up-icon-input"
          ref="input"
          type="file"
          @change="inputChangeFn"
          accept="image/*"
        />
        <div class="up-img-cut-load" v-show="loading && !cut">
          <i class="el-icon-loading"></i>
        </div>
      </div>
      <!--<div class="img-remarks" :style="{height}"><p>长宽比例为{{decimalsToFractional(aspectRatio)}}</p>-->
      <!--<p>图片格式：PNG、JPG、JPEG</p>-->
      <!--</div>-->
    </div>

    <!--裁剪框-->
    <div class="up-img-cut" v-if="cutImg">
      <div class="up-img-cut-cont">
        <div class="up-img-cut-cont-img">
          <img
            style="max-width: 100%; max-height: 100%"
            :src="cutImg"
            ref="cutImg"
          />
        </div>
        <div class="up-img-cut-cont-bot">
          <div class="cont-bot-left">
            <div class="cont-bot-right-but" @click="cropper.rotate(-90)">
              左旋
            </div>
            <div class="cont-bot-right-but" @click="cropper.rotate(90)">
              右旋
            </div>
            <div class="cont-bot-text">鼠标滚轮可放大或缩小图片</div>
          </div>
          <div class="cont-bot-right">
            <div
              class="cont-bot-right-but cont-bot-right-but-confirm"
              :loading="loading"
              @click="saveFn"
            >
              确定
            </div>
          </div>
        </div>
        <div class="up-img-cut-load" v-if="loading">
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </div>

    <!--预览模态框-->
    <div class="preview-modal" v-if="previewVisible">
      <div class="preview-content" :class="{'selection-active': selectionMode}">
        <div class="preview-header">
          <span>图片预览与裁剪</span>
          <i class="el-icon-close" @click="closePreview"></i>
        </div>
        <div class="preview-body">
          <img :src="previewImage" ref="previewImg" />
        </div>
        <div class="preview-footer">
          <div class="preview-controls">
            <div class="control-button" @click="previewCropper && previewCropper.rotate(-90)">
              <i class="el-icon-refresh-left"></i> 左旋转
            </div>
            <div class="control-button" @click="previewCropper && previewCropper.rotate(90)">
              <i class="el-icon-refresh-right"></i> 右旋转
            </div>
            <div class="control-button" @click="enableSelectionMode" v-if="!selectionMode">
              <i class="el-icon-scissors"></i> 开始选择
            </div>
            <div class="control-button" @click="disableSelectionMode" v-else>
              <i class="el-icon-close"></i> 取消选择
            </div>
            <div class="control-tip" v-if="selectionMode">拖拽鼠标框选区域，可调整大小和位置</div>
            <div class="control-tip" v-else>鼠标滚轮可放大或缩小图片</div>
          </div>
          <div class="preview-actions">
            <button class="crop-btn" @click="cropFromPreview" v-if="selectionMode">识别选择内容</button>
          </div>
        </div>

        <!-- 识别的文字结果显示 -->
        <div class="ocr-result" v-if="ocrText">
          <div class="ocr-result-header">
            <span>识别结果</span>
            <div class="ocr-result-actions">
              <button class="copy-btn" @click="copyOcrText">复制</button>
              <button class="close-btn" @click="ocrText = ''">关闭</button>
            </div>
          </div>
          <textarea class="ocr-result-text" readonly v-model="ocrText"></textarea>
        </div>

        <div class="up-img-cut-load" v-if="loading && previewVisible">
          <i class="el-icon-loading"></i>
        </div>
        <div class="up-img-cut-load" v-if="ocrProcessing && previewVisible">
          <div class="ocr-processing">
            <i class="el-icon-loading"></i>
            <div class="ocr-text">正在识别文字...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import { createWorker } from "tesseract.js";

export default {
  name: "up-img",
  props: {
    action: {
      // 上传的七牛云地址
      default() {
        let url = "http://up-z1.qiniu.com";
        if (window.location.protocol === "http:") {
          url = "http://up-z1.qiniu.com";
        } else if (window.location.protocol === "https:") {
          url = "https://upload-z1.qbox.me";
        }
        return url;
      },
    },
    width: {
      // 宽
      default() {
        return 30;
      },
    },
    height: {
      // 高
      default() {
        return 30;
      },
    },
    upFormat: {
      // 限制上传文件的类型
      default() {
        return ["image/jpeg", "image/png"];
      },
    },
    beforeUrl: {
      // 显示地址的前部分
      default() {
        return window.configure.qiniuUrl;
      },
    },
    afterUrl: {
      // 显示地址的后部分
      default() {
        return `?imageView2/1/w/${this.width}/h/${this.height}/format/jpg/q/75%7Cimageslim`;
      },
    },
    file: {
      // 数据
      default() {
        return "";
      },
    },
    files: {
      // 数据组
      default() {
        return "";
      },
    },
    max: {
      // 最大上传，默认为1，只上传单个
      default() {
        return 1;
      },
    },
    cut: {
      // 是否开启裁剪, 默认开启
      default() {
        return true;
      },
    },
    cropperOption: {
      // 裁剪配置项
      default() {
        return {
          dragMode: "move", // 拖拽模式，move-可以移动图片
          viewMode: 0,
          autoCropArea: 1,
          zoomOnWheel: true,
        };
      },
    },
    ratio: {
      // 不裁剪时，上传的图片是否严格按照宽高比例
      default() {
        return false;
      },
    },
    disabled: {
      // 禁用
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      filesArr: [],
      cutImg: "", // 裁剪图片地址
      cropper: null, // 裁剪器
      loading: false, // 加载
      previewVisible: false, // 预览模态框可见性
      previewImage: "", // 预览图片地址
      previewCropper: null, // 预览裁剪器
      selectionMode: false, // 是否开启选择模式
      ocrProcessing: false, // OCR处理中
      ocrText: "", // 识别出的文字
    };
  },
  watch: {
    files(val) {
      if (val) {
        this.filesArr = val.split(",");
      }else{
        this.filesArr = [];
      }
    },
  },
  methods: {
    /**
     * 小数转分数
     * @param decimals 小数
     * @returns {string}
     */
    decimalsToFractional(decimals) {
      if (!decimals) {
        return "不固定";
      }
      if (decimals === parseInt(decimals)) return decimals + " / " + "1";
      let t = decimals.toString().includes(".")
        ? decimals.toString().replace(/\d+[.]/, "")
        : 0;
      let b = Math.pow(10, t.toString().replace("-", "").length);
      if (decimals >= 1) {
        t = +t + Math.floor(decimals) * b;
      } else if (decimals <= -1) {
        t = +t + Math.ceil(decimals) * b;
      }
      let divisor = (function f(a, b) {
        return b ? f(b, a % b) : a;
      })(t, b);
      let x = Math.abs(divisor);
      return t / x + " / " + b / x;
    },
    /**
     * 查看大图
     * @param index
     */
    showFn(index) {
      let max = this.max;
      let imgSrc = "";
      if (max > 1) {
        imgSrc = this.filesArr[index];
      } else {
        imgSrc = this.file;
      }

      // 重置选择模式状态
      this.selectionMode = false;

      // 显示预览模态框
      this.previewImage = `${this.beforeUrl || ''}${imgSrc}`;
      this.previewVisible = true;

      // 下一帧初始化裁剪器
      this.$nextTick(() => {
        let previewImgDom = this.$refs.previewImg;
        if (previewImgDom) {
          this.previewCropper = new Cropper(previewImgDom, {
            viewMode: 1,
            dragMode: 'move',  // 初始为移动模式
            initialAspectRatio: NaN,
            guides: false,     // 初始不显示辅助线
            center: true,
            highlight: false,  // 初始不高亮选择区域
            background: false,
            autoCropArea: 0.6,
            zoomOnWheel: true,
            toggleDragModeOnDblclick: false, // 禁用双击切换
            cropBoxMovable: false,    // 初始禁用裁剪框
            cropBoxResizable: false,  // 初始禁用裁剪框调整大小
            autoCrop: false,          // 禁用自动裁剪框
            modal: false              // 禁用模态层，避免出现选择区域
          });

          // 确保没有裁剪框
          setTimeout(() => {
            if (this.previewCropper && !this.selectionMode) {
              this.previewCropper.clear();
            }
          }, 100);
        }
        // 确保初始状态为false
        this.selectionMode = false;
      });
    },

    /**
     * 关闭预览
     */
    closePreview() {
      if (this.previewCropper) {
        // 移除事件监听器
        const previewImgElement = this.$refs.previewImg;
        if (previewImgElement) {
          previewImgElement.removeEventListener('cropend', this.handleCropEnd);
        }
        this.previewCropper.destroy();
        this.previewCropper = null;
      }
      this.previewVisible = false;
      this.selectionMode = false;
    },

    /**
     * 启用选择模式
     */
    enableSelectionMode() {
      // 确保裁剪器存在且当前不在选择模式
      if (!this.previewCropper || this.selectionMode) return;

      // 保存当前的画布状态（包含缩放和位置信息）
      const currentCanvasData = this.previewCropper.getCanvasData();

      // 显式设置为选择模式
      this.selectionMode = true;

      // 切换到裁剪模式并设置裁剪框
      this.previewCropper.setDragMode('crop');
      this.previewCropper.options.guides = true;
      this.previewCropper.options.highlight = true;
      this.previewCropper.options.cropBoxMovable = true;
      this.previewCropper.options.cropBoxResizable = true;

      // 添加选择完成事件监听器
      const previewImgElement = this.$refs.previewImg;
      if (previewImgElement) {
        previewImgElement.addEventListener('cropend', this.handleCropEnd);
      }

      // 清除现有裁剪框并创建新的
      this.previewCropper.clear();
      // 重新渲染
      this.previewCropper.render();

      // 恢复之前的画布状态（包括缩放和位置）
      this.$nextTick(() => {
        if (this.previewCropper) {
          // 恢复画布状态，包括缩放比例和位置
          this.previewCropper.setCanvasData({
            left: currentCanvasData.left,
            top: currentCanvasData.top,
            width: currentCanvasData.width,
            height: currentCanvasData.height
          });
        }
      });
    },

    /**
     * 处理选择完成事件
     */
    handleCropEnd() {
      // 延迟执行，确保裁剪框已完全设置
      setTimeout(() => {
        if (this.selectionMode) {
          this.cropFromPreview();
        }
      }, 100);
    },

    /**
     * 禁用选择模式
     */
    disableSelectionMode() {
      if (!this.previewCropper) return;

      // 保存当前的画布状态（包含缩放和位置信息）
      const currentCanvasData = this.previewCropper.getCanvasData();

      this.selectionMode = false;

      // 移除选择完成事件监听器
      const previewImgElement = this.$refs.previewImg;
      if (previewImgElement) {
        previewImgElement.removeEventListener('cropend', this.handleCropEnd);
      }

      // 切换回移动模式
      this.previewCropper.setDragMode('move');
      this.previewCropper.options.guides = false;
      this.previewCropper.options.highlight = false;

      // 清除裁剪框
      this.previewCropper.clear();

      // 重新渲染
      this.previewCropper.render();

      // 恢复之前的画布状态（包括缩放和位置）
      this.$nextTick(() => {
        if (this.previewCropper) {
          // 恢复画布状态，包括缩放比例和位置
          this.previewCropper.setCanvasData({
            left: currentCanvasData.left,
            top: currentCanvasData.top,
            width: currentCanvasData.width,
            height: currentCanvasData.height
          });
        }
      });
    },

    /**
     * 从预览中裁剪并生成新图片，并使用OCR识别文字
     */
    cropFromPreview() {
      // 确保裁剪器存在且当前在选择模式
      if (!this.previewCropper || !this.selectionMode) return;

      // 获取裁剪框数据，检查是否有效选择
      const cropBoxData = this.previewCropper.getCropBoxData();
      if (cropBoxData.width < 10 || cropBoxData.height < 10) {
        this.$message.warning("请选择更大的区域");
        return;
      }

      this.loading = true;
      this.ocrProcessing = true;
      this.ocrText = "";

      let canvas = this.previewCropper.getCroppedCanvas();
      let quality = 1;

      // 根据尺寸设置质量
      if (canvas.width > 5000 || canvas.height > 5000) {
        quality = 7;
      } else if (canvas.width > 4000 || canvas.height > 4000) {
        quality = 6.5;
      } else if (canvas.width > 3000 || canvas.height > 3000) {
        quality = 5.5;
      } else if (canvas.width > 2000 || canvas.height > 2000) {
        quality = 3.5;
      } else if (canvas.width > 1000 || canvas.height > 1000) {
        quality = 1.5;
      }

      let canvasData = this.previewCropper.getCroppedCanvas({
        width: canvas.width / quality,
        height: canvas.height / quality,
      });

      // 使用Tesseract.js进行OCR识别
      this.recognizeText(canvasData.toDataURL('image/jpeg'));

      this.loading = false;
    },

    /**
     * 使用Tesseract.js识别图片中的文字
     * @param {string} imageData - 图片的Data URL
     */
    async recognizeText(imageData) {
      this.ocrProcessing = true;
      try {
        // v4.1.1 版本API
        const worker = await createWorker({
          logger: m => console.log(m)
        });

        // 在v4版本中，需要载入语言数据
        await worker.loadLanguage('chi_sim');
        await worker.initialize('chi_sim');

        // 识别文字
        const { data: { text } } = await worker.recognize(imageData);

        // 复制文本到剪贴板
        if (text && text.trim()) {
          const trimmedText = text.trim();
          this.ocrText = trimmedText;
          this.$emit('ocr-text', trimmedText);
          // 自动复制到剪贴板
          this.copyOcrText();
        } else {
          this.ocrText = "";
          this.$message.warning("未能识别到文字");
        }

        await worker.terminate();
      } catch (error) {
        console.error("OCR识别失败:", error);
        this.$message.error("文字识别失败: " + (error.message || error));
      } finally {
        this.ocrProcessing = false;
      }
    },
    /**
     * input change 事件
     */
    inputChangeFn(file) {
      if (file) {
        if (this.upFormat.find((r) => r === file.target.files[0].type)) {
          // 图片类型判断
          if (this.cut) {
            // 开启剪裁
            const url = window.URL || window.webkitURL;
            this.cutImg = url.createObjectURL(file.target.files[0]);
            this.$nextTick(() => {
              let cutImgDom = this.$refs.cutImg;
              if (cutImgDom) {
                this.cropperOption.aspectRatio = this.width / this.height; // 裁剪比例
                this.cropper = new Cropper(cutImgDom, this.cropperOption);
              }
            });
          } else {
            // 不开启剪裁
            let img = new Image();
            img.src = URL.createObjectURL(file.target.files[0]);
            img.onload = () => {
              if (
                this.ratio &&
                img.width / img.height !== this.width / this.height
              ) {
                this.$message.warning(
                  `只能上传长宽像素比为${this.decimalsToFractional(
                    this.width / this.height
                  )}的图片！`
                );
              } else {
                this.upFileFn(file.target.files[0]);
              }
            };
          }
        } else {
          this.$message.warning(
            `只能上传${JSON.stringify(this.upFormat)}类型的文件！`
          );
        }
      }
    },
    /**
     * 取消裁剪
     */
    cancelFn() {
      let input = this.$refs.input;
      if (input) {
        input.value = "";
      }
      this.cutImg = "";
    },
    /**
     * 确定裁剪
     */
    saveFn() {
      let cropper = this.cropper;
      if (cropper) {
        let canvas = cropper.getCroppedCanvas();
        let quality = 1;
        if (canvas.width > 5000 || canvas.height > 5000) {
          quality = 7;
        } else if (canvas.width > 4000 || canvas.height > 4000) {
          quality = 6.5;
        } else if (canvas.width > 3000 || canvas.height > 3000) {
          quality = 5.5;
        } else if (canvas.width > 2000 || canvas.height > 2000) {
          quality = 3.5;
        } else if (canvas.width > 1000 || canvas.height > 1000) {
          quality = 1.5;
        }
        let canvasData = cropper.getCroppedCanvas({
          width: canvas.width / quality,
          height: canvas.height / quality,
        });

        // canvas.toBlob方法兼容ie
        if (!HTMLCanvasElement.prototype.toBlob) {
          Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
            value: function (callback, type, quality) {
              var canvas = this;
              setTimeout(function () {
                var binStr = atob(
                  canvas.toDataURL(type, quality).split(",")[1]
                );
                var len = binStr.length,
                  arr = new Uint8Array(len);

                for (var i = 0; i < len; i++) {
                  arr[i] = binStr.charCodeAt(i);
                }

                callback(new Blob([arr], { type: type || "image/png" }));
              });
            },
          });
        }

        // 获取原始图片类型
        const inputElement = this.$refs.input;
        const fileType = inputElement && inputElement.files[0] ? inputElement.files[0].type : "image/jpeg";

        // 保持原始图片格式，特别是PNG的透明背景
        const outputType = fileType === "image/png" ? "image/png" : "image/jpeg";

        canvasData.toBlob(
          (blob) => {
            this.upFileFn(blob);
          },
          outputType,
          outputType === "image/jpeg" ? 1 : undefined
        );
      }
    },

    /**
     * 上传
     * @param blob
     */
    async upFileFn(blob) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let formData = new FormData();
      let qiniuToken = await this.getQiniuTokenFn();
      formData.append("token", qiniuToken);
      formData.append("file", blob);

      let data = await this.$axios.post(this.action, formData);

      this.loading = false;
      if (data && data.hash) {
        if (this.max > 1) {
          let files = JSON.parse(JSON.stringify(this.filesArr));
          files.push(data.hash);
          this.$emit("update:files", files.join(","));
        } else {
          this.$emit("update:file", data.hash);
        }
        this.$emit("change");
        this.cancelFn();
      } else {
        this.$message.warning("上传失败，请稍后再试~");
      }
    },
    /**
     * 删除
     * @param index
     */
    removeFn(index) {
      let max = this.max;
      if (max > 1) {
        let files = JSON.parse(JSON.stringify(this.filesArr));
        files.splice(index, 1);
        this.$emit("update:files", files.join(","));
        this.$emit("remove", files.join(","));
      } else {
        this.$emit("update:file", "");
        this.$emit("remove", '');
      }
    },
    /**
     * 复制OCR识别的文字到剪贴板
     */
    async copyOcrText() {
      if (!this.ocrText) return;

      try {
        // 现代浏览器 - 使用 Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.ocrText);
          this.$message.success("已复制到剪贴板");
        } else {
          // 兼容性方案 - 创建一个临时元素并使用 document.execCommand
          const textArea = document.createElement('textarea');
          textArea.value = this.ocrText;
          document.body.appendChild(textArea);
          textArea.select();
          const successful = document.execCommand('copy');
          document.body.removeChild(textArea);

          if (successful) {
            this.$message.success("已复制到剪贴板");
          } else {
            this.$message.warning("复制到剪贴板失败");
          }
        }
      } catch (error) {
        console.error("复制到剪贴板失败:", error);
        this.$message.warning("复制到剪贴板失败");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.up-img {
  .img-remarks {
    line-height: 20px;
    color: #999999;
    font-size: 14px;
    margin-left: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .up-img-content {
    display: flex;
    height: 100%;
    align-items: flex-end;
    flex-wrap: wrap;

    .content-img {
      position: relative;
      flex-shrink: 0;
      overflow: hidden;
      border: 1px solid #ebebeb;
      box-sizing: border-box;

      .up-img-content-img {
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      .content-img-actions {
        opacity: 0;
      }

      &:hover .content-img-actions {
        cursor: pointer;
        position: absolute;
        opacity: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 5;
        display: flex;
        align-items: center;
        justify-content: space-around;
        background: rgba(0, 0, 0, 0.6);

        .el-icon-delete {
          color: @color-danger;
          font-size: 20px;
          cursor: pointer;
        }

        .el-icon-view {
          color: @color-success;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }

    .content-img {
      margin-right: 16px;
    }

    .content-img-up {
      border: 1px dashed #ebebeb;
      cursor: pointer;

      .content-img-up-icon-input {
        opacity: 0;
        position: absolute;
        width: 100%;
        height: 100%;
      }

      &:hover {
        background: #f9f9f9;
      }
    }

    .content-img-up-icon {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 24px !important;
      height: 24px !important;
      transform: translate(-50%, -50%);
    }
  }

  .up-img-cut {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;

    .up-img-cut-cont {
      /*position: fixed;*/
      /*left: 50%;*/
      /*top: 50%;*/
      /*transform: translate(-50%, -50%);*/
      padding: 30px 30px 0;
      box-sizing: border-box;
      background: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      width: 45%;
      height: 65%;
      display: flex;
      flex-direction: column;

      .cropper-crop-box {
        overflow: hidden;
        border: 1px solid #39f;
      }

      .up-img-cut-cont-img {
        flex-shrink: 1;
        width: 100%;
        height: 100%;
        overflow: hidden;
        /*overflow: auto;*/
      }

      .up-img-cut-cont-bot {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 0;
        flex-shrink: 0;

        .cont-bot-right,
        .cont-bot-left {
          display: flex;
          align-items: center;
        }

        .cont-bot-right-but {
          padding: 0 10px;
          font-size: 14px;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          color: #606266;
          cursor: pointer;
          border-radius: 4px;
          flex-shrink: 0;
        }

        .cont-bot-right-but-confirm {
          background: #1e9fff;
          color: #fff;
          border-color: #1e9fff;
        }

        .cont-bot-text {
          margin-left: 15px;
          font-size: 14px;
        }

        .cont-bot-right-but + .cont-bot-right-but {
          margin-left: 15px;
        }
      }
    }
  }

  /*上传中loading样式*/

  .up-img-cut-load {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    background: rgba(255, 255, 255, 0.8);
    z-index: 10;

    .ocr-processing {
      display: flex;
      flex-direction: column;
      align-items: center;

      .ocr-text {
        margin-top: 10px;
        font-size: 16px;
        color: #606266;
      }
    }
  }

  .preview-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;

    .preview-content {
      background: #fff;
      padding: 20px;
      border-radius: 4px;
      width: 80%;
      max-width: 1200px;
      height: 80%;
      display: flex;
      flex-direction: column;
      position: relative;

      .preview-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        flex-shrink: 0;

        span {
          font-size: 18px;
          font-weight: bold;
        }

        .el-icon-close {
          cursor: pointer;
          font-size: 20px;
        }
      }

      .preview-body {
        flex: 1;
        overflow: hidden;
        margin-bottom: 15px;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .preview-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;

        .preview-controls {
          display: flex;
          align-items: center;

          .control-button {
            padding: 6px 12px;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            cursor: pointer;
            margin-right: 10px;

            &:hover {
              background: #f5f7fa;
            }

            &.active, .selection-active & {
              background: #ecf5ff;
              border-color: #409eff;
              color: #409eff;
            }
          }

          .control-tip {
            color: #909399;
            font-size: 14px;
          }
        }

        .preview-actions {
          display: flex;

          button {
            padding: 8px 16px;
            margin-left: 10px;
            border: none;
            cursor: pointer;
            border-radius: 4px;
            font-size: 14px;
          }

          .cancel-btn {
            background: #f5f7fa;
            border: 1px solid #dcdfe6;
            color: #606266;

            &:hover {
              background: #e9ecf2;
            }
          }

          .crop-btn {
            background: #1e9fff;
            color: #fff;

            &:hover {
              background: #1e80ff;
            }
          }
        }
      }

      .ocr-result {
        position: absolute;
        bottom: 20px;
        right: 20px;
        width: 300px;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        z-index: 11;

        .ocr-result-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 10px;
          border-bottom: 1px solid #dcdfe6;

          span {
            font-weight: bold;
            font-size: 14px;
          }

          .ocr-result-actions {
            display: flex;

            button {
              padding: 4px 8px;
              margin-left: 5px;
              border: none;
              border-radius: 3px;
              font-size: 12px;
              cursor: pointer;
            }

            .copy-btn {
              background: #ecf5ff;
              color: #409eff;

              &:hover {
                background: #d9ecff;
              }
            }

            .close-btn {
              background: #f5f7fa;
              color: #909399;

              &:hover {
                background: #e9ecf2;
              }
            }
          }
        }

        .ocr-result-text {
          width: 100%;
          height: 150px;
          padding: 10px;
          border: none;
          resize: none;
          font-size: 14px;
          line-height: 1.5;
          color: #606266;
          background: #fafafa;
        }
      }

      // 增强选择框样式
      &.selection-active {
        .cropper-crop-box {
          border: 2px solid #409eff !important;

          .cropper-view-box {
            outline: 2px solid #409eff;
            outline-color: rgba(64, 158, 255, 0.75);
          }

          .cropper-point {
            width: 10px;
            height: 10px;
            opacity: 1;
            background-color: #409eff;

            &.point-e, &.point-w, &.point-n, &.point-s {
              width: 12px;
              height: 12px;
            }
          }

          .cropper-line {
            background-color: #409eff;
          }
        }

        .cropper-face {
          background-color: rgba(64, 158, 255, 0.1);
        }
      }
    }
  }
}

// 添加全局样式覆盖cropper默认样式
.cropper-crop-box {
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 0 1px #409eff;

  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border: 2px dashed #fff;
    opacity: 0.8;
    pointer-events: none;
    animation: dashPulse 2s infinite linear;
  }
}

@keyframes dashPulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.9;
  }
  100% {
    opacity: 0.5;
  }
}

.cropper-point {
  width: 8px !important;
  height: 8px !important;
  opacity: 1 !important;
  background-color: #fff !important;
  border: 2px solid #409eff !important;
}

.cropper-view-box {
  outline: 1px solid #409eff;
  outline-color: rgba(64, 158, 255, 0.75);
}

.cropper-line {
  background-color: #409eff;
}

.cropper-modal {
  opacity: 0.3;
  background-color: #000;
}
</style>

